import { FormInput, InfoBox, TabsNavigation } from 'components/molecules';
import LabeledProviderConnectionStatus from 'components/molecules/labeledStatus/LabeledProviderConnectionStatus';
import { TopBar } from 'components/organisms';
import { TopbarTabs } from 'components/templates';
import { Form, Formik, FormikConfig } from 'formik';
import { useTranslation } from 'react-i18next';
import { IProviderSftpConnectionResponse } from 'services/providers/types';
import { II18nextPrefix } from 'types/components/components.interface';
import {
  booleanSelectOptions,
  useEnumToSelectOptions,
} from 'utils/components/inputs/select';
import { getTabError } from 'utils/global/validation.utils';
import * as Yup from 'yup';
import { IFormikProps, IFormProps } from '../types';
import SftpConnectionKyesTab from './tabs/SftpConnectionKyesTab';

export const sftpConnectionInitialValue: IProviderSftpConnectionResponse = {
  version: 0,
  id: '',
  salesChannelId: '',
  providerId: '',
  isPredefined: false,
  serverAddress: '',
  serverFolder: '',
  login: '',
  password: '',
  portNumber: null,
  //
  completedServerFolder: '',
  keyPrint: '',
  keyPath: '',
  keyPassphrase: '',
  sshHostKeyPolicyId: null,
  preserveTimestamp: false,
  serviceAccepted: false,
  //
  connectionStatusId: null,
  healthCheckDate: null,
};

const sftpConnectionValidationSchema = Yup.object().shape({
  // serverAddress: Yup.string().required(() =>
  //   i18next.t('formik-error.required')
  // ),
  // serverFolder: Yup.string().required(() => i18next.t('formik-error.required')),
  // login: Yup.string().required(() => i18next.t('formik-error.required')),
  // password: Yup.string().required(() => i18next.t('formik-error.required')),
  // portNumber: Yup.number().required(() => i18next.t('formik-error.required')),
});

export enum SftpConnectionTabs {
  keys,
}

export interface SftpConnectionFormProps
  extends FormikConfig<IProviderSftpConnectionResponse>,
    IFormProps,
    II18nextPrefix {}

const SftpConnectionForm = ({
  i18nextPrefix,
  topbarContent,
  tittle,
  status,
  initialValues = sftpConnectionInitialValue,
  backPath,
  customBackItem,
  disableTabs,
  onSubmit,
  ...props
}: SftpConnectionFormProps) => {
  const { t } = useTranslation();
  const { getSelectOptions } = useEnumToSelectOptions();

  return (
    <Formik
      {...props}
      initialStatus={status}
      validateOnChange={true}
      validateOnBlur={true}
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={sftpConnectionValidationSchema}
      onSubmit={onSubmit}>
      {({
        values,
        status,
        errors,
        setFieldValue,
      }: IFormikProps<IProviderSftpConnectionResponse>) => (
        <Form className='w-full h-full'>
          <TopbarTabs>
            <TopBar
              // title={status?.displayMode ? values.serverAddress : undefined}
              customBackItem={customBackItem}
              path={backPath}
              topbarContent={
                <div className='w-full flex justify-between items-center'>
                  <div className='w-60'>
                    <FormInput.Text
                      name='serverAddress'
                      label={t('input.label.serverAddress')}
                      autoFocus
                    />
                  </div>

                  <div className='flex items-center gap-2'>
                    {values.connectionStatusId !== null &&
                      status?.displayMode && (
                        <LabeledProviderConnectionStatus
                          status={values.connectionStatusId}
                        />
                      )}
                    {/* {status?.displayMode ? (
                      <LabeledStatus.Active status={initialValues.isActive} />
                    ) : (
                      <div className='w-44'>
                        <FormInput.Select
                          name='isActive'
                          label={t('input.label.active')}
                          options={getSelectOptions(
                            ACTIVE_STATUS,
                            'enum.ACTIVE_STATUS'
                          )}
                          isDisabled={
                            !status?.displayMode && values.isPredefined
                          }
                        />
                      </div>
                    )} */}
                    {topbarContent}
                  </div>
                </div>
              }>
              <InfoBox loading={status?.isLoading}>
                <InfoBox.Items columns={2}>
                  <FormInput.Text
                    name='portNumber'
                    label={t('input.label.portNumber')}
                    type='number'
                  />
                  <FormInput.Text
                    name='serverFolder'
                    label={t('input.label.serverFolder')}
                  />
                  <FormInput.Text
                    name='completedServerFolder'
                    label={t('input.label.completedServerFolder')}
                  />
                  <FormInput.Select
                    name='preserveTimestamp'
                    label={t('input.label.preserveTimestamp')}
                    options={booleanSelectOptions}
                  />
                  <FormInput.Select
                    name='serviceAccepted'
                    label={t('input.label.serviceAccepted')}
                    options={booleanSelectOptions}
                  />
                </InfoBox.Items>
              </InfoBox>

              <TabsNavigation
                tabs={[
                  {
                    value: SftpConnectionTabs.keys,
                    name: 'keys',
                    error: getTabError([
                      errors.login,
                      errors.password,
                      // errors.keyPassphrase,
                      // errors.keyPath,
                      // errors.keyPrint,
                      // errors.sshHostKeyPolicyId,
                    ]),
                  },
                ]}
                i18nextPrefix={'provider'}
                disabled={disableTabs}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

SftpConnectionForm.getRouterTabs = (disabledChildren?: string[]) =>
  [{ path: 'keys', element: <SftpConnectionKyesTab /> }].filter(
    children => !disabledChildren?.includes(children.path)
  );

export default SftpConnectionForm;
